// src/components/Trusted.jsx
import Reveal from "./Reveal";

const logos = ["Acme", "Quanta", "Nova", "Globo", "Pulse"];

export default function Trusted() {
  return (
    <section className="relative overflow-hidden bg-white">
      
      <div
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          backgroundImage: `
            radial-gradient(600px 400px at 0% 0%,       rgba(32,75,151,.18), transparent 60%),
            radial-gradient(700px 500px at 0% 100%,     rgba(93,131,243,.20), transparent 60%),
            radial-gradient(600px 400px at 100% 0%,     rgba(64,196,198,.20), transparent 60%),
            radial-gradient(700px 500px at 100% 100%,   rgba(54,192,185,.20), transparent 60%)
          `,
        }}
      />

      <div className="relative z-10 mx-auto max-w-7xl px-4 py-4">
        

        <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
          {logos.map((l, i) => (
            <Reveal key={l} delay={i * 0.05}>
              
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
